import { render, staticRenderFns } from "./scrollNumber.vue?vue&type=template&id=1225495c&scoped=true&"
import script from "./scrollNumber.vue?vue&type=script&lang=js&"
export * from "./scrollNumber.vue?vue&type=script&lang=js&"
import style0 from "./scrollNumber.vue?vue&type=style&index=0&id=1225495c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225495c",
  null
  
)

export default component.exports